export class User {
  public id: number = 111;
  public firstname: string = 'Guest';
  public lastname: string = '';
  public email: string = 'guest@example.com';
  public skin: string = 'mdb-skin';
  public language: string = 'fr';
  public profile: string = 'administrator';
}
